// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.InvoiceItemAdjustmentResponse */
/* istanbul ignore next */
@GandalfModel
export class InvoiceItemAdjustmentResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	amount!: number;

	@GandalfProperty({ designType: String })
	details!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number;

	@GandalfProperty({ designType: Number })
	invoiceItemId!: number;

	@GandalfConstantDecorator(constants.InvoiceItemAdjustmentStatus)
	@GandalfProperty({ designType: constants.InvoiceItemAdjustmentStatus })
	status!: constants.InvoiceItemAdjustmentStatus | null;

	@GandalfConstantDecorator(constants.InvoiceItemAdjustmentType)
	@GandalfProperty({ designType: constants.InvoiceItemAdjustmentType })
	type!: constants.InvoiceItemAdjustmentType;

	@GandalfProperty({ designType: Date })
	updatedOn!: Date;

}
